export default __webpack_public_path__ + "static/media/SLS.a446dae0.jpg";